/** App shell, navigation, brand switcher, quick lookup, user menu, blocked / no-access screens. */
export const shell = {
  language: "Language",

  // Sidebar and topbar
  nav: {
    overview: "Overview",
    deposits: "Deposits",
    payouts: "Payouts",
    statement: "Statement",
    developers: "Developers",
    team: "Team",
    activity: "Activity",
    settings: "Settings",
  },
  skipToContent: "Skip to content",
  mainNavigation: "Main navigation",
  homeLabel: "iCryptoNow overview",
  openMenu: "Open menu",
  closeMenu: "Close menu",
  console: "Console",
  security: "Security",
  pausedBanner: "<b>Payouts are paused.</b> New payouts and approvals are on hold until our team resumes them. Deposits keep working.",
  mockData: "Mock data",
  mockDataTitle: "Fake data, nothing is sent to the server",
  demoBanner: "Demo: everything here is sample data and no real money moves. Where a code is asked for, type any 6 digits.",
  testnet: "Testnet",
  testnetTitle: "Test networks only. No real funds.",
  testnetBanner: "Testnet only (TRON Nile, BSC Testnet). Never send real USDT to any address shown here: mainnet funds sent to these addresses cannot be recovered.",

  // User menu
  accountLabel: "Account: {name}",
  account: "Account",
  securitySettings: "Security settings",
  logOut: "Log out",

  // Brand switcher
  switchedTo: "Switched to {name}",
  brandLabel: "Brand: {brand} ({org}). Switch brand",
  switchBrand: "Switch brand",

  // Quick lookup
  lookupButton: "Look up a deposit or payout",
  lookupLabel: "Look up a deposit or payout by player ref, username, request ID, address or tx hash",
  lookupPlaceholder: "Look up player ref, username, request ID, tx hash…",
  closeLookup: "Close lookup",
  matches: "Matches",
  noMatch: "No match. Player refs, usernames and request IDs match from the start; addresses and tx hashes must be complete.",

  // Blocked network (403 ip_not_allowed)
  blockedTitle: "Access from this network is not allowed",
  blockedBody:
    "Your organization only allows the console from approved networks (office, VPN). Connect from one of them, or ask your account owner to add this network. The attempt was logged.",
  blockedContactOwner: "Contact your account owner.",

  // Page the role can't open
  noAccessTitle: "You don't have access to this page",
  noAccessBody: "Your role at {brand} doesn't include it. Switch brand or ask an owner.",
  thisBrand: "this brand",

  // Brand waiting for iCryptoNow approval
  inReviewBanner: "Your account is waiting for iCryptoNow approval. You can look around, add your team and create API keys; deposits, payouts and networks open once we approve you, usually within one business day. Questions: <a>@mrho68 (Telegram)</a>",
  inReviewTag: "In review",
  inReviewHint: "Opens once iCryptoNow approves your account",
  // Customer number and the brand's two Telegram groups (General: talk to us; Finance: payout approvals, money notices)
  customerNo: "Customer no. {number}",
  tgGeneral: "Telegram · Support group",
  tgFinance: "Telegram · Finance",
  tgFinanceHint: "Payout approvals arrive here; only Owners who linked Telegram can approve.",
};
